import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "v-row",
  style: {"gap":"8px","margin":"0 0 1em 0","--button-icon-size":"1.5em"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("播放全部")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加到")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = {
  class: "v-row",
  style: {"flex":"1","align-items":"stretch","overflow":"hidden"}
}
const _hoisted_7 = { class: "cell-text" }
const _hoisted_8 = ["data-mid"]
const _hoisted_9 = ["data-mid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hl_button = _resolveComponent("hl-button")!
  const _component_icon = _resolveComponent("icon")!
  const _component_table_view = _resolveComponent("table-view")!
  const _component_accordion = _resolveComponent("accordion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_hl_button, { icon: "play-select" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_hl_button, { icon: "plus" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_hl_button, { icon: "my-download" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_hl_button, { icon: "trash" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_hl_button, {
        icon: "multiple",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.multiple = !_ctx.multiple))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.multiple ? '退出批量操作' : '批量操作'), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_table_view, {
        style: {"flex":"auto"},
        selection: _ctx.multiple,
        columns: _ctx.columns,
        data: _ctx.songList,
        onRowDblclick: _ctx.playMediaList,
        onInfiniteScroll: _ctx.loadDataList
      }, {
        title: _withCtx(({item}) => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1),
          (item.vip)
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 0,
                class: "vip-icon",
                name: "vip",
                width: "1em",
                height: "1em"
              }))
            : _createCommentVNode("", true),
          (item.vid)
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 1,
                class: "mv-icon",
                name: "mv",
                width: "1em",
                height: "1em"
              }))
            : _createCommentVNode("", true)
        ]),
        singer: _withCtx(({item:{singer:singers = []}}) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singers, (singer, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "link cell-text",
              key: index,
              "data-mid": singer.mid
            }, _toDisplayString(singer.name), 9, _hoisted_8))
          }), 128))
        ]),
        album: _withCtx(({item:{album}}) => [
          album
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "link cell-text",
                "data-mid": album.mid
              }, _toDisplayString(album.name), 9, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["selection", "columns", "data", "onRowDblclick", "onInfiniteScroll"]),
      _createVNode(_component_accordion, {
        style: {"flex":"none"},
        list: _ctx.rankList,
        onChange: _ctx.onRankChanged
      }, null, 8, ["list", "onChange"])
    ])
  ], 64))
}